// import external dependencies
import jquery from 'jquery';

declare global {
  interface Window {
    $: typeof jquery;
    jQuery: typeof jquery;
  }
}

window.$ = window.jQuery = jquery;

import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/offcanvas';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/tab';

import './modules/sticky-header';
import './modules/mobile-menu';
import './modules/sliders';
import './modules/more-faq';
import './modules/share-utility';
import './modules/video-yt';
import './modules/link-like-button';
import './modules/anchor-accordion-open';
import './modules/search';
import './modules/newsletter';
import './modules/see-more';

import './modules/accessconfig';
